import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserBottomContentLayout({children}) {
    // Used in Exercisers to frame bottom content, made of
    // keyboard, erase button, validation slider

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"w-full max-w-[420px] flex flex-col justify-end items-center mt-[80px] mb-[16px]"}>
            {children}
        </div>
    )
}